import { useEffect, useState } from "react";
import { WebSocketChannel } from "../../types/WebSocketChannel";
import type { WebSocketSuggestionsMessage } from "../../types/WebSocketMessage";
import { useWebSocketListener } from "./useWebSocketListener";
import { usePubSub, type UserPromptRecord, useDebug } from "@huub-web/ui";

/**
 * Hook for listening for and managing suggestions.
 */
export const useSuggestions = () => {
  const pubSub = usePubSub();
  const { log } = useDebug();

  const [suggestions, setSuggestions] = useState<UserPromptRecord[]>([]);

  const clearSuggestions = () => {
    setSuggestions([]);
  };

  // Listen for suggestions on websocket
  // ----------------------------------

  useWebSocketListener<WebSocketSuggestionsMessage>(
    WebSocketChannel.SUGGESTIONS,
    ({ data }) => {
      log(
        "cyan",
        "useSuggestions",
        "addSuggestions through websocket",
        data.data?.suggestions,
      );
      setSuggestions(data.data?.suggestions ?? []);
    },
  );

  // Listen for add suggestions on pubsub
  // ----------------------------------

  useEffect(() => {
    const unsubscribe = pubSub.subscribe("addSuggestions", (suggestions) => {
      log(
        "cyan",
        "useSuggestions",
        "addSuggestions through pubsub",
        suggestions,
      );
      setSuggestions(suggestions);
    });

    return () => {
      unsubscribe();
    };
  }, [pubSub]);

  return {
    suggestions,
    clearSuggestions,
  };
};
